//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CouponCard from '@/components/CouponCard';
import XInput from 'vux/src/components/x-input';
import XButton from 'vux/src/components/x-button';
import XDialog from 'vux/src/components/x-dialog';
import { sendCode } from '@/api/login';
import { receiveCouponAndBinding } from '@/api/activity';
import { mapState } from 'vuex';
import { setTitle } from '@/utils';
import { roleTypeMap } from '@/utils/map';
import UBT from '@/utils/ubt';
import env from '@/utils/env';
import Storage from '@/utils/storage';

const mobileTest = /^1[0-9]{10}$/;

const smsTest = /^[0-9]{4}$/;

export default {
  components: {
    CouponCard,
    XInput,
    XButton,
    XDialog
  },
  data() {
    return {
      inputVal: '',
      imageKaptcha: '',
      visable: false,
      form: {
        mobile: '',
        smsCode: '',
      },
      releaseTime: 0,
      activityId: '',
      roleType: '',
      hasSend: false,
    };
  },

  computed: {
    disabled() {
      return !this.validMobilePase || !this.validSmsCodePase;
    },
    inputVals() {
      return (this.inputVal || '').split('') || [];
    },
    canSend() {
      return this.releaseTime <= 0;
    },
    validMobilePase() {
      return mobileTest.test(this.form.mobile || '');
    },
    validSmsCodePase() {
      return smsTest.test(this.form.smsCode || '');
    },
    loginText() {
      if (!this.roleType) return '立即领取';
      return {
        1: '获取我的名片',
        2: '申请成为推广员',
        4: '立即领取',
      }[this.roleType] || '立即领取';
    },
    UIconfig() {
      switch (+this.roleType) {
        case +roleTypeMap.leader:
          return {
            url: this.activity.leaderUrl,
            color: this.activity.leaderColour
          };
        case +roleTypeMap.member:
          return {
            url: this.activity.memberUrl,
            color: this.activity.memberColour
          };
        default:
          return {
            url: this.activity.couponUrl,
            color: this.activity.couponColour
          };
      }
    },
    activityRules() {
      return (this.activity.activityRule || '').split('<br>') || [];
    },
    ...mapState({
      activity: state => state.activity.activity
    })
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.initState();
      this.initResaseTime();
    },
    initState() {
      const { activityId, sourceId, autologin } = this.$route.query;
      let { roleType = roleTypeMap.user } = this.$route.query;
      if (!activityId) {
        throw new Error('活动不存在');
      }
      if ([+roleTypeMap.leader, +roleTypeMap.member].indexOf(+roleType) === -1) {
        // 不认识的roleType都默认为用户领券
        roleType = roleTypeMap.user;
      }
      let pageId = '';
      switch (+roleType) {
        case 1:
          pageId = 'H5_换电_领队登录页';
          break;
        case 2:
          pageId = 'H5_换电_队员登录页';
          break;
        default:
          pageId = 'H5_换电_用户领券页未登录状态';
      }
      if (pageId) {
        UBT.pageView({
          pageId,
          additionValue: env.isWeixin ? '微信' : '其他',
          additionType: '展示终端',
        });
      }
      Object.assign(this, { activityId, roleType, sourceId });
      this.getActivity(activityId, roleType);
      if (
        +autologin === 1
        && +roleType === +this.$store.state.user.loginResult.roleType
        && +activityId === +this.$store.state.user.loginResult.activityId
        && (!this.$store.state.user.loginResult.sourceId
        || (sourceId === this.$store.state.user.loginResult.sourceId))
      ) {
        this.afterLogin();
      }
    },
    onBlur() {
      window.scrollTo(0, 0);
    },
    async getActivity(activityId, roleType) {
      try {
        await this.$store.dispatch('getActivity', { activityId, roleType });
        if (+this.roleType === +roleTypeMap.leader) {
          setTitle('领队认证');
        } else if (+this.roleType === +roleTypeMap.member) {
          setTitle('成为推广员');
        } else {
          setTitle(this.activity.activityName);
        }
      } catch (e) {
        this.$throw(e);
      }
    },
    initResaseTime() {
      const lastSendTime = Storage.getItem('last-send-time') || 0;
      const now = Date.now();
      const releaseTimeMs = 60000 - (now - lastSendTime);
      const releaseTime = releaseTimeMs < 0
        ? 0
        : parseInt((releaseTimeMs) / 1000, 10);
      this.releaseTimeTask(releaseTime);
    },
    async login() {
      const {
        form: { mobile: mobilePhone, smsCode } = {},
        activityId,
        roleType,
        sourceId,
      } = this;
      try {
        if (!mobileTest.test(mobilePhone)) {
          throw new Error('请输入正确手机号');
        }
        await this.$store.dispatch('login', {
          mobilePhone,
          smsCode,
          activityId,
          roleType,
          sourceId,
        });
        this.afterLogin(true);
      } catch (e) {
        this.$throw(e);
      }
    },
    async afterLogin(isClick) {
      const {
        roleType,
        activityId,
        sourceId,
      } = this;
      if (+roleType === 1) {
        // 领队
        this.$router.replace({
          name: 'share',
          query: {
            roleType,
            activityId,
          }
        });
      } else if (+roleType === 2) {
        // 队员
        this.$router.replace({
          name: 'share',
          query: {
            roleType,
            activityId,
            sourceId,
          }
        });
      } else {
        // 用户领取
        try {
          if (isClick) {
            UBT.clickButton({
              buttonName: 'H5_换电_用户领券页未登录状态_领券',
              pageId: 'H5_换电_用户领券页未登录状态',
            });
          }
          await receiveCouponAndBinding({
            activityId,
            memberUserId: sourceId
          });
          this.$router.replace({
            name: 'activity',
            query: {
              roleType,
              activityId,
              sourceId,
            }
          });
        } catch (e) {
          this.$throw(e);
        }
      }
    },
    async getImageCaptcha() {
      if (!this.validMobilePase) {
        return;
      }
      try {
        const res = await sendCode({
          mobile: this.form.mobile,
        });
        if (res.ok) {
          this.hasSend = true;
          this.$vux.toast.show({
            type: 'text',
            width: 'auto',
            text: '发送成功',
          });
          this.releaseTimeTask(60);
          Storage.setItem('last-send-time', Date.now());
        } else if (+res.imageStatus === 1) {
          this.imageKaptcha = res.imageCaptcha;
          window.scrollTo(0, 0);
          this.visable = true;
          this.inputVal = '';
        } else {
          throw new Error('发生未知错误');
        }
      } catch (e) {
        this.$throw(e);
      }
    },
    async handelInput() {
      if (this.inputVal.length >= 4) {
        try {
          const res = await sendCode({
            mobile: this.form.mobile,
            capText: this.inputVal,
          });
          if (res.ok) {
            this.visable = false;
            this.hasSend = true;
            this.$vux.toast.show({
              type: 'text',
              width: 'auto',
              text: '发送成功',
            });
            this.releaseTimeTask(60);
            Storage.setItem('last-send-time', Date.now());
          } else if (+res.imageStatus === 2) {
            this.imageKaptcha = res.imageCaptcha;
            this.inputVal = '';
            throw new Error('图片验证码输入错误');
          } else {
            throw new Error('发生未知错误');
          }
        } catch (e) {
          this.$throw(e);
        }
      }
    },
    releaseTimeTask(releaseTime) {
      this.releaseTime = releaseTime;
      if (releaseTime > 0) {
        setTimeout(() => {
          this.releaseTimeTask(releaseTime - 1);
        }, 1000);
      } else {
        Storage.removeItem('last-send-time');
      }
    }
  }
};
